import { useSyncExternalStore } from 'react';

/**
 * Roteamento por URL do app do tenant (History API, sem dependência externa).
 * O Worker `web` já serve `index.html` para qualquer path (SPA fallback do
 * Static Assets, ADR-001), então deep link e F5 chegam aqui com a URL intacta.
 */

/** Evento disparado após pushState/replaceState (o browser só emite popstate no voltar/avançar). */
const NAVIGATE_EVENT = 'econd:navigate';

/** Remove barras finais: `/faturas/` e `/faturas` são a mesma rota; raiz continua `/`. */
export function normalizePath(pathname: string): string {
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

function subscribe(onChange: () => void): () => void {
  window.addEventListener('popstate', onChange);
  window.addEventListener(NAVIGATE_EVENT, onChange);
  return () => {
    window.removeEventListener('popstate', onChange);
    window.removeEventListener(NAVIGATE_EVENT, onChange);
  };
}

/** Path atual normalizado; re-renderiza em navegação programática e no voltar/avançar. */
export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => normalizePath(window.location.pathname));
}

/**
 * Navega para `path`. `replace` troca a entrada do histórico (redirecionamentos),
 * para o voltar do navegador não cair de novo na rota que redirecionou.
 */
export function navigate(path: string, options: { replace?: boolean } = {}): void {
  if (options.replace) window.history.replaceState(null, '', path);
  else if (normalizePath(window.location.pathname) !== normalizePath(path)) {
    window.history.pushState(null, '', path);
  }
  window.dispatchEvent(new Event(NAVIGATE_EVENT));
}
